module.exports = __webpack_public_path__ + "src-notif-travelStaytion.png?e7acb8218779f3a13771ef559bc4b279";